import React from 'react'
import DocumentTitle from 'react-document-title'
import Backdrop from '../components/backdrop'

/**
 * Not found page
 */
class NotFound extends React.Component {
  render() {
    return (
      <DocumentTitle title="Page not found">
        <Backdrop url="/images/library.jpg">
          <h2>Sorry!</h2>
          <p>We couldn't find that page.</p>
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./modules/shared/pages/notFound.js